import { type ComponentProps } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, Button, DisplayText, Modal, type ModalDialogue, theme } from '@sg/garnish';

import { CustomizationModalContentContainer } from '../CustomizationModalContentContainer';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationRestrictionModal = (props: Props) => {
  const { restrictionText, onRequestClose, ...modalProps } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal withCloseBtn={false} onRequestClose={onRequestClose} {...modalProps}>
      <CustomizationModalContentContainer size="lg">
        <DisplayText sizeMatch={['32']}>
          <FormattedMessage {...messages.title} values={{ text: restrictionText.toLowerCase() }} />
        </DisplayText>

        <View style={styles.ctaContainer}>
          <Button
            palette="kale"
            size="large-wide"
            style={styles.cta}
            accessibilityLabel={formatMessage(messages.gotIt)}
            onPress={onRequestClose}
          >
            <BodyText sizeMatch={['18']} style={styles.buttonText}>
              <FormattedMessage {...messages.gotIt} />
            </BodyText>
          </Button>
        </View>
      </CustomizationModalContentContainer>
    </Modal>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  ctaContainer: {
    alignItems: 'center',
    paddingTop: theme.spacing['2'],
  },
  cta: {
    minWidth: 246,
    height: 72,
  },
  buttonText: {
    color: theme.colors.KALE,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Please note — this ingredient {text}.',
    description: 'Customization | Restriction modal | Text',
  },
  gotIt: {
    defaultMessage: 'Got it',
    description: 'Customization | Restriction modal | Button title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  restrictionText: string;
} & ComponentProps<typeof ModalDialogue>;
